import { CreditCard, CalendarClock } from 'lucide-react';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';

export function PaymentsHubPage() {
  const rows: SettingsRowDef[] = [
    {
      id: 'payment-methods',
      label: 'Payment Methods',
      desc: 'Stripe Connect, offline methods, and custom messages.',
      icon: CreditCard,
      path: '/admin/payments/payment-methods',
    },
    {
      id: 'payment-schedule',
      label: 'Payment Schedule',
      desc: 'Default deposit, balance split, and lock-in moving date.',
      icon: CalendarClock,
      path: '/admin/payments/payment-schedule',
    },
  ];

  return (
    <HubPageLayout
      title="Payments"
      subtitle="Payment methods, schedule, and policies."
      rows={rows}
    />
  );
}
